import axios from "axios";
import { createContext, useContext, useEffect, useState } from "react";
import { io } from "socket.io-client";
import { useRef } from "react";
import toast from "react-hot-toast";
// const server = process.env.SERVER_URL;
const server = process.env.REACT_APP_SERVER_URL;
// Create the context object
export const MyContext = createContext();

// Create a context provider component
const MyContextProvider = ({ children }) => {

  const [user, setUser] = useState(() => {
    try {
      const storedUser = localStorage.getItem("user");

      if (!storedUser || storedUser === "undefined" || storedUser === "null") {
        localStorage.removeItem("user");
        return null;
      }

      return JSON.parse(storedUser);
    } catch (err) {
      console.error("Invalid user in localStorage");
      localStorage.removeItem("user");
      return null;
    }
  });

  const [socket, setSocket] = useState(null);
  const [selectedPhoneNumberId, setSelectedPhoneNumberId] = useState("");
  const [getAllowedFeatures, setGetAllowedFeatures] = useState(null);

  const [phoneOverviewData, setPhoneOverviewData] = useState(null);
  const [profileInfoData, setProfileInfoData] = useState(null);

  const [callState, setCallState] = useState(null);


  const peerConnectionRef = useRef(null);
  const localStreamRef = useRef(null);

  const setLocalStream = (stream) => {
    localStreamRef.current = stream;
  };


  const mapStatus = (status) => {
    console.log("Mapping call status:", status);
    switch (status) {
      case "ringing":
        return "ringing";
      case "accepted":
        return "connected";
      case "connected":
        return "connected";
      case "completed":
      case "rejected":
      case "missed":
        return "ended";
      default:
        return "calling";
    }
  };


  const getUser = () => {
    if (user) return user;

    const u = JSON.parse(localStorage.getItem("user"));
    if (u) {
      setUser(u);
      return u;
    }
    return false;
  };


  useEffect(() => {
    if (user) {
      localStorage.setItem("user", JSON.stringify(user));
    } else {
      // localStorage.removeItem("user");
    }
  }, [user]);

  const getConfig = () => {
    try {
      const stored = localStorage.getItem("user");
      if (!stored) return {};

      const parsed = JSON.parse(stored);
      const token = parsed?.token;

      if (!token) return {};

      return {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
    } catch (err) {
      console.error("Invalid token in localStorage");
      localStorage.removeItem("user");
      return {};
    }
  };

  useEffect(() => {
    getAllowedUserFeatures().then((data) => {
      // console.log("User data in Sidebar:", data);
      setGetAllowedFeatures(data);
    });
  }, [user]);

  const loginWithFacebook = async (data) => {
    try {


      const response = await axios.post(
        `${server}/auth/facebook`,
        data,
        getConfig()
      );

      const result = response.data; // Your backend response

      if (result.requiresEmail) {
        // store token TEMPORARILY (not full login)

        return result;
      } else {
        if (result?.token) {
          const newData = { token: result.token };
          loginUser(newData);
        }
      }

      return result;
    } catch (error) {
      console.error(
        "❌ Facebook login error:",
        error.response?.data || error.message
      );
      throw error.response?.data || error;
    }
  };

  const completeProfile = async (data) => {
    try {
      const { email, token } = data;



      if (!email || !token) {
        throw { message: "Email and token are required" };
      }

      console.log("Completing profile with email:", email);
      console.log("Using token:", token);
      // 👉 IMPORTANT: use token manually here (not getConfig)
      const response = await axios.post(
        `${server}/auth/facebook/complete-profile`,
        { email },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const result = response.data;

      // ✅ Now finalize login (same as normal login)
      if (result?.success) {
        const newData = {
          token: token, // 👈 keep same token
        };

        loginUser(newData); // 🔥 this was missing
      }

      return result;
    } catch (error) {
      console.error(
        "❌ Complete profile error:",
        error.response?.data || error.message
      );
      throw error.response?.data || error;
    }
  };


  // 3️⃣ Normal login logic reused for Facebook
  const loginUser = (userData) => {
    try {
      localStorage.setItem("user", JSON.stringify(userData));
      setUser(userData);

      // 4️⃣ Connect socket
      const s = io(server, {
        auth: { token: userData.token },
      });

      s.on("connect", () => {
        // console.log("/🟢 Socket connected:", s.id);
      });

      s.on("disconnect", () => {
        // console.log("🔴 Socket disconnected");
      });

      setSocket(s);

      return true;
    } catch (err) {
      console.error("loginUser error:", err);
      return false;
    }
  };


  const logoutUser = () => {
    if (socket) {
      socket.disconnect();
      // console.log("🔴 Socket manually disconnected on logout");
    }
    setSocket(null);
    setGetAllowedFeatures(null);
    localStorage.removeItem("user");
    setUser(null);
  };




  // ✅ Automatically connect socket if user already exists (on refresh)

  useEffect(() => {
    if (user && !socket) {
      const s = io(server, {
        auth: { token: user.token },
      });

      s.on("connect", () => {
        console.log("🟢 Socket connected:", s.id);
      });

      s.on("disconnect", () => {
        console.log("🔴 Socket disconnected");
      });

      setSocket(s);
    }
  }, [user]);


  const cleanupCall = () => {
    if (peerConnectionRef.current) {
      peerConnectionRef.current.getSenders().forEach(s => s.track?.stop());
      peerConnectionRef.current.close();
      peerConnectionRef.current = null;
    }

    if (localStreamRef.current) {
      localStreamRef.current.getTracks().forEach(t => t.stop());
      localStreamRef.current = null;
    }

    setCallState(null);
  };


  useEffect(() => {
    if (!socket) return;


    const handleCallEnded = () => {
      cleanupCall();
    };

    socket.on("call:ended", handleCallEnded);
    return () => {
      socket.off("call:ended", handleCallEnded);
    };
  }, [socket]);

  useEffect(() => {
    if (!socket) return;

    const handleCallStatus = (call) => {
      console.log("📞 call:status", call);

      setCallState(prev => {
        if (!prev || prev.call_id !== call.call_id) return prev;

        return {
          ...prev,
          status: mapStatus(call.status)
        };
      });
    };

    socket.on("call:status", handleCallStatus);
    return () => socket.off("call:status", handleCallStatus);
  }, [socket]);





  useEffect(() => {
    if (!socket) return;

    const handleSDP = async (call) => {
      console.log("📡 call:event (SDP handler)", call);

      if (!peerConnectionRef.current) return;

      if (call.remoteSDPType === "answer") {
        await peerConnectionRef.current.setRemoteDescription({
          type: "answer",
          sdp: call.remoteSDP
        });
      }
    };

    socket.on("call:event", handleSDP);
    return () => socket.off("call:event", handleSDP);
  }, [socket]);

  useEffect(() => {
    if (!socket) return;

    const handleCallEvent = (call) => {
      console.log("📡 call:event", call);

      setCallState(prev => {
        // 🔹 New call
        if (!prev) {
          return {
            type: call.direction === "outgoing" ? "outgoing" : "incoming",
            // status: mapStatus(call.status || "ringing"),
            status:
              call.status === "connected"
                ? "connected"
                : call.status || "ringing",
            call_id: call.call_id,
            from: call.from, 
            to: call.to,
            phone_number_id: call.phone_number_id,
            remoteSDP: call.remoteSDP || null,
            remoteSDPType: call.remoteSDPType || null
          };
        }

        // 🔹 Same call → update
        if (prev.call_id === call.call_id) {
          return {
            ...prev,
            status: mapStatus(call.status || prev.status),
            remoteSDP: call.remoteSDP || prev.remoteSDP,
            remoteSDPType: call.remoteSDPType || prev.remoteSDPType
          };
        }

        return prev;
      });
    };

    socket.on("call:event", handleCallEvent);
    return () => socket.off("call:event", handleCallEvent);
  }, [socket]);


  const toggleMuteCall = () => {
    if (!localStreamRef.current) {
      console.log("❌ No local stream");
      return;
    }

    const audioTrack = localStreamRef.current.getAudioTracks()[0];

    if (!audioTrack) {
      console.log("❌ No audio track");
      return;
    }

    audioTrack.enabled = !audioTrack.enabled;

    console.log("🎤 Mic toggled:", audioTrack.enabled ? "ON" : "OFF");

    return audioTrack.enabled; // return state
  };








  const ForgotPassword = async (data) => {
    const response = await axios.post(`${server}/user/forgot-password`, data);
    return response.data;
  };

  const VerifyOtp = async (data) => {
    const response = await axios.post(`${server}/user/verify-otp`, data);
    return response.data;
  };

  const ResetPassword = async (data) => {
    const response = await axios.post(`${server}/user/reset-password`, data);
    return response.data;
  };








  const getAllowedUserFeatures = async () => {
    try {
      const res = await axios.get(`${server}/user/me`, getConfig());
      // console.log("User data :", res.data)
      return res.data;
    } catch (error) {
      console.error("Error fetching user data:", error);
      if (error.status === 401) {
        setGetAllowedFeatures(null);
        localStorage.removeItem("user");
        setUser(null);

      }
      return null; // return null if there’s an error
    }
  };


  const checkAccountStatus = async () => {
    try {
      const { data } = await axios.get(
        `${server}/user/account-status`,
        getConfig()
      );

      return data;
    } catch (error) {
      console.error("Error checking account status:", error);

      throw (
        error.response?.data || {
          message: "Something went wrong",
        }
      );
    }
  };

  

  const getPhoneAll = async () => {
    try {
      const response = await axios.get(`${server}/phone/all`, getConfig());

      if (!response?.data) {
        throw new Error("No data returned from server");
      }

      // console.log("Fetched phones:", response.data);
      return response.data;
    } catch (error) {
      // Log for debugging 
      console.error("Failed to fetch phones:", error);

      // Rethrow the error so the caller can handle it
      throw error;
    }
  };




  const getRecipientMessages = async (phoneId, params) => {
    const response = await axios.get(`${server}/message/recipient/${phoneId}?${params}`, getConfig());
    return response.data;
  };




  const getAllRecipientByPhoneId = async (phoneId, page = 1) => {
    const response = await axios.get(
      `${server}/message/recipients/${phoneId}?page=${page}`,
      getConfig()
    );
    return response.data;
  };


  const getAllRecipientByPhoneIdWithStatus = async (phoneId, page = 1) => {
    try {
      const url = `${server}/message/recipients/status/${phoneId}?page=${page}`;

      const response = await axios.get(url, getConfig());
      return response.data;

    } catch (error) {
      console.error("Error fetching recipients:", error.response?.data || error.message);
      return { data: [], pagination: { page, limit: 20, total: 0, totalPages: 0, hasMore: false } };
    }
  };



  const searchConversations = async ({ phoneNumberId, search = "" }) => {
    try {
      if (!search.trim()) {
        return { data: [] };
      }

      const params = new URLSearchParams({ search });

      const url = `${server}/message/${phoneNumberId}/conversations?${params.toString()}`;

      const response = await axios.get(url, getConfig());

      return response.data; // { data: [...] }
    } catch (error) {
      console.error(
        "Error searching conversations:",
        error.response?.data || error.message
      );

      return { data: [] };
    }
  };




  const fetchCSWStatus = async (phoneId, messageID) => {
    try {
      const response = await axios.get(
        `${server}/message/csw-status/${phoneId}/${messageID}`,
        getConfig()
      );
      // console.log("fetchCSWStatus response:", response.data);
      return response.data;

    } catch (error) {
      console.error("fetchCSWStatus error:", error.response?.data || error.message);
      throw error;
    }
  };


  // toggle bot activation for a contact
  const toggleBotForConversation = async ({ phoneNumberId, messageID, status, }) => {
    try {
      const res = await axios.patch(
        `${server}/message/toggle-bot`,
        {
          phoneNumberId,
          messageID,
          status: Boolean(status),
        },
        getConfig()
      );

      return res.data;
    } catch (error) {
      console.error(
        "Error toggling bot:",
        error.response?.data || error.message
      );
      throw error;
    }
  };

  const fetchBotStatus = async ({ phoneNumberId, messageID }) => {
    try {
      const res = await axios.get(
        `${server}/message/bot-status`,
        {
          params: {
            phoneNumberId,
            messageID,
          },
          ...getConfig(),
        }
      );

      console.log("fetchBotStatus response:", res.data);
      return res.data;
    } catch (error) {
      console.error(
        "Error fetching bot status:",
        error.response?.data || error.message
      );
      throw error;
    }
  };









  const createTemplate = async (data) => {
    try {

      const response = await axios.post(
        `${server}/template/create`,
        data,
        getConfig()
      );
      return response.data;
    } catch (error) {
      console.error("createTemplate error:", error.response?.data || error.message);
      throw error;
    }
  };

  const createImageTemplate = async (data) => {
    const response = await axios.post(
      `${server}/template/upload-image-handle`,
      data,
      getConfig()
    );
    return response.data;
  };

  const getAllTemplate = async () => {
    const response = await axios.get(`${server}/template/all`, getConfig());
    return response.data;
  };



  // const getTemplateByWabaId = async (wabaId) => {
  //   // console.log("context api res:", wabaId)
  //   const response = await axios.get(
  //     `${server}/template/temp/${wabaId}`,
  //     getConfig()
  //   );
  //   return response.data;
  // };


  const getTemplateByWabaId = async (wabaId, page = 1, limit = 10) => {
    // console.log("context api res:", wabaId)
    const response = await axios.get(
      `${server}/template/temp/${wabaId}`,
      {
        ...getConfig(),
        params: {
          page,
          limit
        }
      }
    );
    return response.data;
  };



  const getUserWabaIds = async () => {
    try {
      const config = getConfig();
      // console.log("Config used:", config); // Debug
      const response = await axios.get(`${server}/user/getUserWabaIds`, config);
      return response.data;
    } catch (err) {
      console.error(
        "Error in getUserWabaIds:",
        err.response?.data || err.message
      );
      throw err;
    }
  };

  // {{url}}/send-messages
  const sendBulkCsv = async (payload) => {
    const response = await axios.post(
      `${server}/send-messages`,
      payload, // This is the body
      {
        headers: { "Content-Type": "application/json" }, // optional if server already parses JSON
        ...getConfig() // merge any auth headers if needed
      }
    );
    return response.data;
  };




  const Login = async (data) => {
    try {
      const response = await axios.post(
        `${server}/user/login`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Login error:", error.response?.data || error.message);
      throw error;
    }
  };
  const LoginTwoFactorVerify = async (data) => {
    try {
      const response = await axios.post(
        `${server}/user/login/2fa-verify`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Login error:", error.response?.data || error.message);
      throw error;
    }
  };



  // {{url}}/createContact
  const createContact = async (data) => {

    console.log("createContact data:", data);
    try {
      const response = await axios.post(
        `${server}/createContact`,
        data,
        getConfig()
      );

      console.log("createContact response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Create contact error:", error.response?.data || error.message);
      if (error.response?.status === 403) {
        toast.error(error.response?.data?.message || "You don't have permission to create contacts.");
      }
      else {
        toast.error(error.response?.data?.message || "Failed to create contact.");
      }
      throw error;
    }
  };

  const getNumberInfo = async (phoneNumber) => {
    try {
      const response = await axios.get(`${server}/contact/${phoneNumber}`, {
        ...getConfig(),
      });
      return response.data;
    } catch (err) {
      console.error("Server error:", err);
      throw err;
    }
  }




  const getContacts = async (data) => {

    const { search, page = 1, limit = 50, filters = [] } = data
    // console.log("data in Context::", data)
    // console.log("data in Context filters::", data.activeFilters)
    try {
      const response = await axios.post(
        `${server}/getContacts`,
        {
          search,
          page,
          limit,
          filters, // send structured array of filters
        },
        getConfig() // your auth headers
      );

      return response.data;
    } catch (error) {
      console.error("getContacts error:", error.response?.data || error.message);
      throw new Error(error.response?.data?.message || error.message);
    }
  };


  const getFullContacts = async (filters = {}) => {
    try {
      // Send only search/filters, no page or limit
      const response = await axios.get(`${server}/getContactss`, {
        params: filters,
        ...getConfig(),
      });
      return response.data;
    } catch (err) {
      console.error("getContacts API error:", err);
      throw err;
    }
  };



  // atrributes for each contact 
  const getAttributes = async () => {
    const response = await axios.get(`${server}/attributes`, {
      ...getConfig(),
    });
    return response.data;
  }
  // {{url}}/contact/upload

  const contactFileCsv = async (formData) => {
    const response = await axios.post(`${server}/contact/upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        ...getConfig().headers,
      },
    });
    return response.data;
  };

  // http://localhost:5000/google/sync
  const syncGoogleContacts = async (formData) => {
    try {
      const response = await axios.post(
        `${server}/google/sync`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            ...getConfig().headers,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Sync Google contacts error:", error.response?.data || error.message);
      throw error;
    }
  };

  // {{url}}/deleteContact/68190574094908a35f2f508d
  const deleteContact = async (id) => {
    try {
      const response = await axios.delete(
        `${server}/deleteContact/${id}`,
        getConfig()
      );
      return response.data;
    } catch (error) {
      console.error(
        "Delete contact failed:",
        error.response?.data || error.message
      );
      throw error;
    }
  };

  const Register = async (data) => {
    try {
      const response = await axios.post(
        `${server}/user/register`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Register error:", error.response?.data || error.message);
      throw error;
    }
  };
  const verifyOtpAbndRegister = async (data) => {
    try {
      // console.log("verifyOtpAbndRegister", data)
      const response = await axios.post(
        `${server}/user/verifyOtpAndRegister`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Register error:", error.response?.data || error.message);
      throw error;
    }
  };
  const resendOtpOnRegister = async (data) => {
    try {
      // console.log("verifyOtpAbndRegister", data)
      const response = await axios.post(
        `${server}/user/resendOtpOnRegister`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Register error:", error.response?.data || error.message);
      throw error;
    }
  };





  // http://localhost:3000/messages/send
  const SentMessage = async (data) => {
    const response = await axios.post(
      `${server}/messages/send`,
      data,
      getConfig()
    );
    return response.data;
  };

  // http://localhost:3000/messages/receive

  const ReceiveMessage = async (data) => {
    const response = await axios.post(
      `${server}/messages/receive`,
      data,
      getConfig()
    );
    return response.data;
  };

  // http://localhost:3000/messages/chat/id_1/id_2
  const SendReceiveMessageBetweenUsers = async (sender, receiver) => {
    const response = await axios.get(
      `${server}/messages/chat/${sender}/${receiver}`,
      getConfig()
    );
    return response.data;
  };


  const SendMessage = async (data) => {
    const response = await axios.post(
      `${server}/message/text`,
      data,
      getConfig()
    );
    return response.data;
  };




  // const GetMediaUrl = async (media_id, phone_number_id) => {

  //   console.log("GetMediaUrl: ", media_id, phone_number_id);
  //   try {
  //     const response = await axios.get(`${server}/media/url`, {
  //       params: {
  //         media_id,
  //         phone_number_id,
  //       },
  //       responseType: 'blob', // THIS is important
  //       ...getConfig(),
  //     });

  //     const blobUrl = URL.createObjectURL(response.data); // 👈 Create image URL
  //     return blobUrl;
  //   } catch (error) {
  //     console.error('GetMediaUrl error:', error.response?.data || error.message);
  //     throw error;
  //   }
  // };


  const mediaCache = new Map();
  const pendingRequests = new Map();

  const GetMediaUrl = async (media_id, phone_number_id) => {
    const key = `${phone_number_id}-${media_id}`;

    // Already downloaded
    if (mediaCache.has(key)) {
      return mediaCache.get(key);
    }

    // Someone else is already downloading it
    if (pendingRequests.has(key)) {
      return pendingRequests.get(key);
    }

    const request = axios
      .get(`${server}/media/url`, {
        params: {
          media_id,
          phone_number_id,
        },
        responseType: "blob",
        ...getConfig(),
      })
      .then((response) => {
        const blobUrl = URL.createObjectURL(response.data);

        mediaCache.set(key, blobUrl);
        pendingRequests.delete(key);

        return blobUrl;
      })
      .catch((error) => {
        pendingRequests.delete(key);
        throw error;
      });

    pendingRequests.set(key, request);

    return request;
  };

  const GetMediaUrlForTemplate = async (templateName, wabaId) => {


    try {
      const response = await axios.get(`${server}/media/url-from-template`, {
        params: {
          template_name: templateName,
          waba_id: wabaId,
        },
        responseType: 'blob', // THIS is important
        ...getConfig(),
      });

      const blobUrl = URL.createObjectURL(response.data); // 👈 Create image URL
      return blobUrl;
    } catch (error) {
      console.error('GetMediaUrlForTemplate error:', error.response?.data || error.message);
      throw error;
    }
  };

  const SendVoiceMessage = async ({ phone_number_id, recipient_id, file }) => {
    try {
      const formData = new FormData();
      formData.append("phone_number_id", phone_number_id);
      formData.append("recipient_id", recipient_id);
      formData.append("file", file);

      const response = await axios.post(
        `${server}/message/send-voice`,
        formData,
        getConfig()
      );

      return response.data;
    } catch (error) {
      console.error("SendVoiceMessage error:", error.response?.data || error.message);
      throw error;
    }
  };

  const SendReaction = async (payload) => {
    try {
      // const payload = {
      //   messageId,
      //   userId,
      //   emoji,
      // };

      const response = await axios.post(
        `${server}/message/reaction`,
        payload,
        getConfig()
      );

      return response.data;
    } catch (error) {
      console.error("SendReaction error:", error.response?.data || error.message);
      throw error;
    }
  };

  const updateContact = async (id, payload) => {

    try {
      const response = await axios.put(
        `${server}/contacts/${id}`,
        payload,
        getConfig()
      );
      const updated = response.data;
      return updated;
    } catch (error) {
      console.error("updateContact error:", error.response?.data || error.message);
      toast.error(error.response?.data?.message || "Failed to update contact.");
      throw error;
    }
  };


  const updateBulkContacts = async (payload, options = {}) => {
    const controller = new AbortController();

    try {
      const response = await axios.put(
        `${server}/contacts/bulk/tags`,
        payload,
        {
          ...getConfig(),
          signal: controller.signal,
          timeout: 15000, // 15s safeguard
          ...options,     // allow overrides
        }
      );

      return response.data;
    } catch (error) {
      // Normalize error
      const normalizedError = {
        status: error.response?.status || 500,
        message:
          error.response?.data?.message ||
          error.message ||
          "Bulk update failed",
        data: error.response?.data || null,
      };

      console.error("updateBulkContacts:", normalizedError);

      throw normalizedError;
    }
  };

  const uploadTemplateMedia = async (formData) => {
    try {
      const response = await axios.post(
        `${server}/template/upload-media`,
        formData,
        getConfig()
      );
      return response.data;
    } catch (error) {
      console.error("Media upload failed:", error.response?.data || error.message);
      throw error.response?.data || error;
    }
  };




  // Save compaign 
  const saveCampaign = async (campaignData) => {
    try {
      const response = await axios.post(
        `${server}/campaigns/save-campaign`,   // use server variable, not hardcoded
        campaignData,
        getConfig()                  //  includes Authorization header if needed
      );
      return response.data;
    } catch (error) {
      console.error("Save campaign error:", error.response?.data || error.message);
      throw error;
      // if (error.response && error.response.data?.error) {
      //   throw new Error(error.response.data.error);
      // }
      // // console.error("Unexpected error:", error.message);
      // throw new Error("Failed to save campaign");
    }
  };

  // fetch compinas 
  const fetchCampaigns = async (page = 1, search = "", status = "") => {
    try {
      const response = await axios.get(`${server}/campaigns`, {
        params: {
          page,
          limit: 10, // or use ITEMS_PER_PAGE
          ...(search && { search }),
          ...(status && { status }),
        },
        ...getConfig(), // includes Authorization header
      });

      return response.data; // your API should return { data: [...], total: ... } or similar
    } catch (error) {
      console.error(
        "Fetch campaigns error:",
        error.response?.data || error.message
      );
      throw error.response?.data || error;
    }
  };
  // compign details 
  const getCampaignDetails = async (campaignId) => {
    try {
      const response = await axios.get(
        ` ${server}/campaigns/${campaignId}`,
        getConfig()
      );

      if (response.data.success) {
        return response.data; // contains full campaign details
      } else {
        throw new Error("Failed to fetch campaign details.");
      }
    } catch (error) {
      console.error(
        "getCampaignById error:",
        error.response?.data || error.message
      );
      throw error;
    }
  };

  const getCampaignMessages = async (campaignId, page = 1, limit = 10) => {
    try {
      const response = await axios.get(`
        ${server}/campaigns/${campaignId}/messages?page=${page}&limit=${limit}`,
        getConfig()
      );

      if (response.data.success) {
        return response.data; // includes messages + pagination
      } else {
        throw new Error("Failed to fetch campaign messages.");
      }
    } catch (error) {
      console.error(
        "getCampaignMessages error:",
        error.response?.data || error.message
      );
      throw error;
    }
  };

  const uploadMediatoGetID = async (formData) => {
    try {
      const response = await axios.post(
        `${server}/media/upload-send-media`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            ...getConfig().headers, // includes Authorization: Bearer <token>
          },
        }
      );

      return response.data; // this is your `result` from backend
    } catch (error) {
      console.error("uploadMediatoGetID error:", error.response?.data || error.message);
      throw error.response?.data || error;
    }
  };


  const uploadMediaToWhatsApp = async (formData) => {
    try {
      const response = await axios.post(
        `${server}/media/upload`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            ...getConfig().headers, // includes Authorization: Bearer <token>
          },
        }
      );

      return response.data; // this is your `result` from backend
    } catch (error) {
      console.error("uploadMediatoGetID error:", error.response?.data || error.message);
      throw error.response?.data || error;
    }
  };


  const connectWhatsAppWithFacebook = async (code) => {
    try {
      // console.log("📲 Connecting WhatsApp with Facebook using code:", code);

      const response = await axios.post(
        `${server}/auth/facebook/access_token`,
        code,
        getConfig() // if you’re including headers like token
      );

      const result = response.data;
      // console.log("✅ WhatsApp Connection Response:", result);

      if (result.success) {
        // alert("WhatsApp connected successfully!");
      } else {
        // alert(result.message || "Failed to connect WhatsApp");
      }

      return result;
    } catch (error) {
      console.error("❌ WhatsApp connection error:", error.response?.data || error.message);
      throw error.response?.data || error;
    }
  };


  // Get user credits
  const getCredits = async () => {
    try {
      const response = await axios.get(`${server}/user/credits`, getConfig());
      return response.data;
    } catch (error) {
      console.error("Get credits error:", error.response?.data || error.message);
      throw error;
    }
  };

  const getWorkflows = async () => {
    try {

      const res = await axios.get(`${server}/workflows`, getConfig());
      return res.data;
    } catch (error) {
      // console.log("Error loading workflows:", error)
      throw error
    }
  };



  const createWorkflow = async (data) => {
    try {
      const response = await axios.post(
        `${server}/workflows`,
        data,
        getConfig()
      );

      return response.data;
    } catch (error) {
      const err = error.response?.data || {
        success: false,
        message: error.message || "Something went wrong",
      };

      console.error("❌ Create workflow error:", err);
      throw err;
    }
  };

  const deleteWorkflow = async (workflowId) => {
    try {
      const response = await axios.delete(
        `${server}/workflows/${workflowId}`,
        {
          ...getConfig(),
          // data: { workflowId }, // ✅ correct way to send body in DELETE
        }
      );

      return response.data;
    } catch (error) {
      const err = error.response?.data || {
        success: false,
        message: error.message || "Something went wrong",
      };

      console.error("❌ Delete workflow error:", err);
      throw err;
    }
  };




  const updateWorkflow = async (data) => {
    try {
      const response = await axios.put(`${server}/workflows`, data, getConfig());
      return response.data;
    } catch (error) {
      const err = error.response?.data || {
        success: false,
        message: error.message || "Something went wrong",
      };
      console.error("❌ Update workflow error:", err);
      throw err;
    }
  };


  const toggleWorkflowStatus = async (data) => {

    try {
      const res = await axios.patch(
        `${server}/workflows/toggle`,
        data,
        getConfig()
      );
      return res.data;
    } catch (error) {
      console.error("❌ Toggle workflow status error:", error);
      throw error;
    }

  };



  const uploadPdf = async (file, data) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      // formData.append("data", data);

      Object.entries(data).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          formData.append(key, value);
        }
      });


      const response = await axios.post(
        `${server}/knowledge/upload`,
        formData,
        {
          ...getConfig(),
          headers: {
            ...getConfig().headers,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (error) {
      const err = error.response?.data || {
        success: false,
        message: error.message || "Something went wrong",
      };

      console.error("❌ PDF upload error:", err);
      throw err;
    }
  };

  const fetchFiles = async (phone_number_id) => {

    try {
      const response = await axios.get(
        `${server}/knowledge/files/${phone_number_id}`,
        getConfig()
      );

      // console.log("✅ Fetched files response:", response.data);
      return response.data;
    } catch (error) {
      const errData =
        error.response?.data || {
          success: false,
          message: error.message || "Something went wrong while fetching files",
        };

      console.error("❌ Fetch files error:", errData);
      throw error;
    }
  };

  const deleteKnowledgeFile = async ({ phone_number_id, file_id }) => {
    if (!phone_number_id || !file_id) {
      throw new Error("Missing phone_number_id or file_id");
    }

    try {
      const res = await axios.delete(
        `${server}/knowledge/file/${phone_number_id}/${file_id}`,
        getConfig()
      );

      if (!res.data?.success) {
        throw new Error(res.data?.message || "Delete failed");
      }

      return res.data;
    } catch (err) {
      const message =
        err.response?.data?.message ||
        err.message ||
        "Failed to delete knowledge file";

      console.error("❌ Delete knowledge file error:", err);
      throw new Error(message);
    }
  };


  const registerPhone = async (data) => {
    try {
      const res = await axios.post(
        `${server}/auth/facebook/whatsapp/register`,
        data,
        getConfig()
      );
      return res.data;
    } catch (err) {
      console.error("Register phone failed", err.response?.data || err.message);

      // Return structured error so frontend can handle it
      return {
        success: false,
        message:
          err.response?.data?.error?.error_user_msg ||
          err.response?.data?.message ||
          "Failed to register WhatsApp phone",
        details: err.response?.data.details || "",
      };
    }
  };


  // const disconnectPhone = async (phone_number_id) => {
  //   try {
  //     const res = await axios.post(
  //       `${server}/auth/facebook/whatsapp/disconnect`,
  //       { phone_number_id },
  //       getConfig()
  //     );
  //     return res.data;
  //   } catch (err) {
  //     console.error("Disconnect phone failed", err);
  //    throw err;
  //   }
  // };


  const disconnectPhone = async (phone_number_id) => {
    try {
      const res = await axios.post(
        `${server}/auth/facebook/whatsapp/disconnect`,
        { phone_number_id },
        getConfig()
      );

      return {
        success: true,
        message: res.data.message,
        data: res.data
      };

    } catch (err) {
      console.error("Disconnect phone failed", err.response?.data || err.message);

      const status = err.response?.status;
      const data = err.response?.data;

      // Meta rate limit
      if (status === 429) {
        throw {
          success: false,
          code: data?.code || 429,
          message:
            data?.message ||
            "Too many attempts. Please wait before trying again.",
          details: data?.details || null
        };
      }

      // General backend errors
      throw {
        success: false,
        code: status || 500,
        message:
          data?.error ||
          data?.message ||
          "Failed to disconnect WhatsApp phone"
      };
    }
  };

  const blockUser = async (payload) => {
    try {
      const { data } = await axios.post(
        `${server}/whatsapp/blocked-user`,
        payload,
        getConfig()
      );
      return data;
    } catch (error) {
      // Provide clear error context
      const message = error.response?.data?.message || error.message || "Unknown error";
      console.error("BlockUsers error:", message);
      throw new Error(message);
    }
  };

  const checkBlockedUser = async ({ phoneNumberId, phone }) => {
    try {
      const { data } = await axios.get(
        `${server}/whatsapp/blocked-users/check`,
        {
          params: { phoneNumberId, phone },
          ...getConfig(),
        }
      );

      return data;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "Failed to check blocked status";

      throw new Error(message);
    }
  };




  const deleteBlockedUser = async ({ phoneNumberId, phone }) => {
    try {
      const { data } = await axios.delete(
        `${server}/whatsapp/blocked-users/${phoneNumberId}/${phone}`,
        getConfig()
      );

      return data;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "Failed to unblock user";

      console.error("deleteBlockedUser error:", message);
      throw new Error(message);
    }
  };


  const updateAllowBroadcast = async (data) => {


    try {
      const { contacts, allowBroadcast, } = data
      const response = await axios.patch(
        `${server}/contacts/broadcast`,
        {
          contacts: contacts,
          allowBroadcast: allowBroadcast,
        },
        getConfig()
      );
      return response.data;
    } catch (error) {
      console.error("Error updating broadcast:", error.response || error);
      throw error;
    }
  };


  /**
   * Pre-accept an incoming WhatsApp call
   */

  const handlePreAccept = async (payload) => {
    try {
      const { data } = await axios.post(
        `${server}/call/pre-accept-call`,
        payload,
        getConfig()
      );
      return data;
    } catch (error) {
      const message = error.response?.data?.error || error.message || "Pre-accept failed";
      console.error("handlePreAccept error:", message);
      throw new Error(message);
    }
  };

  /**
   * Accept a WhatsApp call after SDP is ready
   */
  const handleAcceptCall = async (payload) => {
    try {
      const { data } = await axios.post(
        `${server}/call/accept-call`,
        payload,
        getConfig()
      );
      return data;
    } catch (error) {
      const message = error.response?.data?.error || error.message || "Call accept failed";
      console.error("handleAcceptCall error:", message);
      throw new Error(message);
    }
  };

  /**
   * Terminate a WhatsApp call
   */
  const handleTerminateCall = async (payload) => {
    try {
      const { data } = await axios.post(
        `${server}/call/terminate-call`,
        payload,
        getConfig()
      );
      return data;
    } catch (error) {
      const message = error.response?.data?.error || error.message || "Terminate call failed";
      console.error("handleTerminateCall error:", message);
      throw new Error(message);
    }
  };




  const startCall = async ({ to, phone_number_id }) => {
    try {
      console.log("📞 Starting outgoing call...");

      // 1️⃣ Create PeerConnection FIRST
      const pc = new RTCPeerConnection({
        iceServers: [{ urls: "stun:stun.l.google.com:19302" }]
      });

      peerConnectionRef.current = pc;

      // 2️⃣ Setup listeners BEFORE anything else
      pc.ontrack = (event) => {
        console.log("🎧 Remote track received");

        setCallState(prev => ({
          ...prev,
          remoteStream: event.streams[0] // pass to UI
        }));
      };

      pc.onicecandidate = (event) => {
        if (event.candidate) {
          console.log("🧊 Sending ICE");

          socket.emit("call:ice-candidate", {
            candidate: event.candidate,
            to
          });
        }
      };

      pc.onconnectionstatechange = () => {
        console.log("🔗 Connection:", pc.connectionState);
      };

      // 3️⃣ Get local stream
      const localStream = await navigator.mediaDevices.getUserMedia({ audio: true });
      localStreamRef.current = localStream;

      localStream.getTracks().forEach(track => {
        pc.addTrack(track, localStream);
      });

      // 4️⃣ Create OFFER
      const offer = await pc.createOffer();
      await pc.setLocalDescription(offer);

      console.log("📤 Sending OFFER");

      // 5️⃣ Call backend
      // const res = await axios.post(`${server}/call/start-call`, {
      const res = await axios.post(`${server}/call/start`, {
        to,
        phone_number_id,
        sdp: offer.sdp
      },
        getConfig()

      );

      console.log("✅ Call initiated, backend response:", res.data);


      // 6️⃣ Set UI state
      setCallState({
        type: "outgoing",
        status: "calling",
        call_id: res.data?.data.calls[0]?.id || null, // save call_id for later use
        to,
        phone_number_id
      });

      return res.data;
    } catch (err) {
      console.error("❌ startCall failed:", err.response?.data?.error || "Failed to start call");
      throw err;
      // toast.error(err.response?.data?.error?.message || err.message || "Failed to start call");
    }
  };




  const checkPermission = async ({ to, phone_number_id }) => {
    try {
      const res = await axios.get(
        `${server}/call/permission`,
        {
          params: { to, phone_number_id },
          ...getConfig()
        }
      );

      return res.data;
    } catch (err) {
      console.error("❌ checkPermission error:", err.response?.data || err.message);
      throw err;
    }
  };

  const requestPermission = async ({ to, phone_number_id }) => {
    try {
      const res = await axios.post(
        `${server}/call/permission-request`,
        { to, phone_number_id },
        getConfig()
      );

      return res.data;
    } catch (err) {
      console.error("❌ requestPermission error:", err.response?.data || err.message);
      throw err;
    }

  };


  //  TWO FACTOR AUTH APIs

  // Enable 2FA



  const enableTwoFactor = async (method) => {
    try {
      const response = await axios.post(
        `${server}/user/2fa/enable`,
        { method },   // "email" or "phone"
        getConfig()
      );

      return response.data;
    } catch (error) {
      const err =
        error.response?.data || {
          success: false,
          message: error.message || "Failed to enable 2FA",
        };

      console.error("Enable 2FA error:", err);
      throw err;
    }
  };


  // Verify OTP
  const verifyTwoFactor = async (otp) => {
    try {
      const response = await axios.post(
        `${server}/user/2fa/verify`,
        { otp },
        getConfig()
      );

      return response.data;
    } catch (error) {
      const err =
        error.response?.data || {
          success: false,
          message: error.message || "Failed to verify OTP",
        };

      console.error("Verify 2FA error:", err);
      throw err;
    }
  };


  // Disable 2FA
  const disableTwoFactor = async () => {
    try {
      const response = await axios.post(
        `${server}/user/2fa/disable`,
        {},
        getConfig()
      );

      return response.data;
    } catch (error) {
      const err =
        error.response?.data || {
          success: false,
          message: error.message || "Failed to disable 2FA",
        };

      console.error("Disable 2FA error:", err);
      throw err;
    }
  };




  //  Get WhatsApp Phone Overview Info
  const getPhoneOverviewInfo = async (phone_number_id) => {
    try {
      const res = await axios.get(
        `${server}/whatsapp/phones/${phone_number_id}/health`,
        getConfig()
      );

      setPhoneOverviewData(res.data);
      setSelectedPhoneNumberId(phone_number_id);

      // console.log("Phone Health:", res.data);
      return res.data;
    } catch (err) {
      console.error("getPhoneOverviewInfo error:", err.response?.data || err.message);
      throw err;
    }
  };


  // Get WhatsApp Business Profile Info
  const getProfileInfo = async (phone_number_id) => {
    try {
      const res = await axios.get(
        `${server}/whatsapp/phones/${phone_number_id}/profile`,
        getConfig()
      );

      const profile = res.data?.data || res.data || null;

      setProfileInfoData(profile);
      setSelectedPhoneNumberId(phone_number_id);

      // console.log("Profile Info:", profile);
      return profile;
    } catch (err) {
      console.error("getProfileInfo error:", err.response?.data || err.message);
      throw err;
    }
  };

  //  Update Business Profile Info
  const updateProfileInfo = async (phone_number_id, payload) => {
    try {
      const res = await axios.patch(
        `${server}/whatsapp/phones/${phone_number_id}/profile`,
        payload,
        getConfig()
      );

      const result = res.data;

      // instant UI update
      if (result?.data) {
        setProfileInfoData(result.data);
      }

      // console.log("Profile Updated:", result);
      return result;
    } catch (error) {
      console.error(
        "updateProfileInfo error:",
        error.response?.data || error.message
      );
      throw error.response?.data || error;
    }
  };


  const getDisplayName = async (phone_number_id) => {
    try {
      const res = await axios.get(
        `${server}/whatsapp/phones/${phone_number_id}/display-name`,
        getConfig()
      );
      // console.log("Display Name:", res.data);
      return res.data?.data || null;

    } catch (error) {
      console.error(
        "❌ getDisplayName error:",
        error.response?.data || error.message
      );
      throw error;
    }
  };

  const updateDisplayName = async (phone_number_id, payload) => {
    try {
      const res = await axios.post(
        `${server}/whatsapp/phones/${phone_number_id}/display-name`,
        payload,
        getConfig()
      );

      return res.data?.data || null;
    } catch (error) {
      console.error(
        "❌ updateDisplayName error:",
        error.response?.data || error.message
      );
      throw error;
    }
  };

  // GET calling settings
  const getCallingSettings = async (phone_number_id) => {
    try {
      const res = await axios.get(
        `${server}/whatsapp/phones/${phone_number_id}/calling-settings`,
        getConfig()
      );

      // console.log(" Calling Settings API:", res.data);

      return res.data || null;
    } catch (error) {
      console.error(
        "❌ getCallingSettings error:",
        error.response?.data || error.message
      );
      throw error;
    }
  };

  // Update WhatsApp calling settings for a phone
  const updateCallingSettings = async (phone_number_id, payload) => {
    try {
      const response = await axios.patch(
        `${server}/whatsapp/phones/${phone_number_id}/calling-settings`,
        payload,
        getConfig()
      );

      // console.log(" Calling settings updated:", response.data);
      return response.data;
    } catch (error) {
      console.error(
        "❌ updateCallingSettings error:",
        error.response?.data || error.message
      );
      throw error.response?.data || error;
    }
  };


  const createAgent = async (data) => {
    try {
      const response = await axios.post(
        `${server}/user/create`,
        data,
        getConfig()
      );

      return response.data;
    } catch (error) {
      console.error(
        "Create agent error:",
        error.response?.data || error.message
      );
      throw error.response?.data || error;
    }
  };

  const getUsers = async () => {
    try {
      const response = await axios.get(
        `${server}/user/users`,
        getConfig()
      );
      console.log("Get users response:", response.data);
      return response.data;
    } catch (error) {
      console.error(
        "Get users error:",
        error.response?.data || error.message
      );
      throw error.response?.data || error;
    }
  };

  const updateAgentPermissions = async (agentId, permissions) => {
    try {
      const response = await axios.put(
        `${server}/user/${agentId}/permissions`,
        { permissions },
        getConfig()
      );
      return response.data;
    } catch (error) {
      console.error("updateAgentPermissions error:", error.response?.data || error.message);
      throw error.response?.data || error;
    }
  };

  const deleteAgent = async (agentId) => {
    try {
      const response = await axios.delete(
        `${server}/user/${agentId}`,
        getConfig()
      );
      return response.data;
    } catch (error) {
      console.error("deleteAgent error:", error.response?.data || error.message);
      throw error.response?.data || error;
    }
  };

  const updateAgentFeatures = async (userId, features) => {
    try {
      const response = await axios.put(
        `${server}/user/${userId}/features`,
        { features },
        getConfig()
      );
      console.log("updateAgentFeatures response:", response.data);
      return response.data;
    } catch (error) {
      console.error(
        "updateUserFeatures error:",
        error.response?.data || error.message
      );
      throw error.response?.data || error;
    }
  };

  const swagger = async () => {
    try {
      const response = await axios.get(
        `${server}/api-docs/`,
        // getConfig()
      );
      console.log("Swagger JSON:", response.data);
      return response.data;
    } catch (error) {
      console.error("Swagger fetch error:", error.response?.data || error.message);
      throw error.response?.data || error;
    }
  };


  // Create API Token
  const createApiToken = async (wabaId, name) => {
    try {
      const response = await axios.post(
        `${server}/user/create-api-token`,
        { wabaId, name },
        getConfig()
      );

      return response.data;
    } catch (error) {
      const err = error.response?.data || error.message;
      console.error("Create API Token Error:", err);
      throw err;
    }
  };


  // Get User Tokens
  const fetchUserTokens = async (wabaId) => {
    try {
      const response = await axios.get(
        `${server}/user/tokens/${wabaId}`,
        getConfig()
      );

      return response.data;
    } catch (error) {
      const err = error.response?.data || error.message;
      console.error("Fetch User Tokens Error:", err);
      throw err;
    }
  };


  // Revoke/ Activate Token
  const toggleApiTokenStatus = async (wabaId, tokenId, action) => {
    try {
      const response = await axios.post(
        `${server}/user/tokens/${wabaId}/${tokenId}`,
        { action: action }, // "revoke" or "delete"
        getConfig()
      );

      return response.data;
    } catch (error) {
      const err = error.response?.data || error.message;
      console.error("Revoke API Token Error:", err);
      throw err;
    }
  };
  // Delete Token
  const deleteApiToken = async (wabaId, tokenId) => {
    try {
      const response = await axios.delete(
        `${server}/user/tokens/${wabaId}/${tokenId}`,
        getConfig()
      );

      return response.data;
    } catch (error) {
      const err = error.response?.data || error.message;
      console.error("Delete API Token Error:", err);
      throw err;
    }
  };


  // Get trail status 
  const fetchTrailStatus = async () => {
    try {
      const response = await axios.get(`${server}/user/trial-status`, getConfig());
      return response.data;
    } catch (error) {
      console.error("Fetch trial status error:", error.response?.data || error.message);
      throw error;
    }
  }

  const provider = {
    // getUserData,
    getAllowedUserFeatures,
    getAllowedFeatures,
    user,
    socket,
    getUser,
    loginUser,
    SentMessage,
    Register,
    verifyOtpAbndRegister,
    resendOtpOnRegister,
    ReceiveMessage,
    SendReceiveMessageBetweenUsers,
    getUserWabaIds,
    deleteContact,
    contactFileCsv,
    syncGoogleContacts,

    createContact,
    getContacts,
    getFullContacts,
    createTemplate,
    sendBulkCsv,
    getTemplateByWabaId,
    getAllTemplate,
    Login,
    LoginTwoFactorVerify,
    getPhoneAll,
    createImageTemplate,
    logoutUser,
    selectedPhoneNumberId,
    setSelectedPhoneNumberId,


    getRecipientMessages,
    getAllRecipientByPhoneId,
    SendMessage,
    GetMediaUrl,
    SendVoiceMessage,
    SendReaction,
    getAttributes,
    updateContact,
    uploadTemplateMedia,
    saveCampaign,
    fetchCampaigns,
    getCampaignDetails,
    uploadMediatoGetID,



    loginWithFacebook,
    completeProfile,
    ForgotPassword,
    VerifyOtp,
    ResetPassword,

    connectWhatsAppWithFacebook,

    getCampaignMessages,
    getCredits,
    fetchCSWStatus,
    getWorkflows,
    createWorkflow,
    deleteWorkflow,
    updateWorkflow,
    toggleWorkflowStatus,
    uploadPdf,
    fetchFiles,
    deleteKnowledgeFile,
    registerPhone,
    disconnectPhone,
    toggleBotForConversation,
    fetchBotStatus,


    getNumberInfo,
    uploadMediaToWhatsApp,

    getAllRecipientByPhoneIdWithStatus,

    searchConversations,
    updateBulkContacts,
    blockUser,
    checkBlockedUser,
    deleteBlockedUser,
    updateAllowBroadcast,

    handlePreAccept,
    handleAcceptCall,
    handleTerminateCall,



    enableTwoFactor,
    verifyTwoFactor,
    disableTwoFactor,




    getPhoneOverviewInfo,
    phoneOverviewData,

    getProfileInfo,
    profileInfoData,
    updateProfileInfo,

    getDisplayName,
    updateDisplayName,

    getCallingSettings,
    updateCallingSettings,

    createAgent,
    getUsers,
    updateAgentPermissions,
    deleteAgent,
    updateAgentFeatures,


    //  user,
    // socket,
    startCall,
    checkPermission,
    requestPermission,
    setCallState,
    cleanupCall,
    callState,
    peerConnectionRef,
    localStreamRef,
    setLocalStream,
    toggleMuteCall,

    swagger,
    createApiToken,
    fetchUserTokens,
    toggleApiTokenStatus,
    deleteApiToken,
    GetMediaUrlForTemplate,
    fetchTrailStatus,
    checkAccountStatus


  };

  return <MyContext.Provider value={provider}>{children}</MyContext.Provider>;
};

const useAPI = () => useContext(MyContext);

export { MyContextProvider, useAPI };
